import React, {Component} from "react";

import {connect} from 'react-redux'

import {withRouter} from "react-router-dom";
import {compose} from 'recompose';
import moment from 'moment'
import PropTypes from 'prop-types'
import {Box, Card, Flex, Text} from "rebass";
import {DefaultText, LeavesDate, LeavesHeading, LeaveStatus, Status} from "../Base/styles";
import {withFirebase} from "../Firebase";
import {schoolActions, schoolSelectors} from "../../store/school";
import {authActions, authSelectors} from "../../store/auth";


const DEAN = [4, 7, 8, 10, 11, 12];
const PARENT = [5, 7, 9, 10, 11, 12];
const HOST = [6, 8, 9, 10, 11, 12];

// const APPROVED = [7, ]
class LeavesCard extends Component {

	state = {
		loading: true,
		student: {first_name: '', last_name: ''}
	};

	componentDidMount() {

		const {details, firebase} = this.props;
		this.listener = firebase.student(details.student_uid).get().then(doc => this.setState({student: {id: doc.id, ...doc.data()}}))

	}

	componentWillUnmount() {
		// this.listener()
	}

	onDetail = () => {
		const { details, history, type, leaveTypes } = this.props;
		history.push(`/app/leaves/${details.id}`);
		localStorage.setItem('leaveType', type);
		if (leaveTypes) {
			localStorage.setItem('leaveTypes', leaveTypes);
		}
	}

	render() {
		const {details, missed, schoolInfo, noBorder, hideName} = this.props;
		const {student} = this.state;

		const types = schoolInfo.leaveTypes;
		const type = types[details.leave_type];
		const startDate = moment.unix(details.start_date).format('MMM DD     hh:mm A');
		const endDate = moment.unix(details.end_date).format('MMM DD     hh:mm A');


		// set status dot color
		let statusColor = 'yellow';
		let hostColor = 'white';
		let deanColor = 'gray';
		let parentColor = 'gray';
		const status = details.status;


		if (student && student.parents && details && details.host && details.host.length > 0 && !details.parent_host) {

			if (HOST.includes(status)) {
				hostColor = 'green'
			} else {
				hostColor = 'gray'
			}
			if (details.status >= 10) {
				statusColor = 'green'
			}
		} else {
			if ((details.parent_host && details.status === 7) || details.status > 7) {
				statusColor = 'green'
			}
		}

		if (details.status > 0 && details.status < 4) {
			statusColor = 'red'
		}
		if (DEAN.includes(status)) {
			deanColor = 'green'
		}
		if (PARENT.includes(status)) {
			parentColor = 'green'
		}

		if (status === 1) {
			deanColor = 'red'
		}
		if (status === 2) {
			parentColor = 'red'
		}
		if (status === 3) {
			hostColor = 'red'
		}

		let isMissed = missed;
		// if(details.start_date  < Math.floor(Date.now() / 1000) && details.status < 11){
		// 	isMissed = true
		// }
		return (
			<Box py={2} onClick={this.onDetail}>

					<Card  variant={noBorder ? 'leavebar' : 'leaves'} width={[1, '95%']} ml={[0, '12px']}>
						<Flex>

							<Box ml={[1, 3]} width={1}>
								<LeavesHeading color={isMissed ? 'red' : 'black'}><Status bg={statusColor}/>{type && type.name}</LeavesHeading>
								{!hideName && <DefaultText mt={'4px'} fontWeight={600} ml={'16px'}>{student.first_name} {student.last_name}</DefaultText>}
								<Flex flexWrap={'wrap'} flexDirection={'row'} width={1}>
									<Box>
										<LeavesDate fontWeight={600} ml={'16px'}>{startDate} - {endDate} {isMissed && '(Missed)'} </LeavesDate>
									</Box>
									<Box mr={'auto'}/>
									<Box>
										<LeaveStatus bg={hostColor} color={hostColor === 'gray' ? 'gray' : 'white'}>
											<Text mt={'3px'} color={'white'}>H</Text></LeaveStatus>
										<LeaveStatus bg={deanColor} color={deanColor === 'gray' ? 'gray' : 'white'}>
											<Text mt={'3px'} color={'white'}>D</Text></LeaveStatus>
										<LeaveStatus bg={parentColor} color={parentColor === 'gray' ? 'gray' : 'white'}>
											<Text mt={'3px'} color={'white'}>P</Text></LeaveStatus>
									</Box>
								</Flex>
							</Box>


						</Flex>
					</Card>
			</Box>
		)
	}

}

LeavesCard.propTypes = {
	details: PropTypes.object,
	missed: PropTypes.bool,
	noBorder: PropTypes.bool,
	hideName: PropTypes.bool,
	type: PropTypes.string
};

LeavesCard.defaultProps = {
	details: {
		status: 'Pending',
		type: 'Vacation Leave',
		leave_by: 'Parents',
		return_by: "Parents",
		leave_at: 'Mar 27, 2018 13:02',
		return_at: 'Apr 3, 2018 15:00',
		host: 'Mom',
		destination: 'New York City'
	},
	missed: false,
	noBorder: false,
	hideName: false,
	type: 'Pending'
};

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loading: authSelectors.isLoading(state.auth),
	isFaculty: authSelectors.isFaculty(state.auth),
});

const mapDispatchToProps = (dispatch) => ({
	updateSchoolInfo: (data) => {
		dispatch(schoolActions.updateSchoolInfo(data))
	},
	updateProfileInfo: (data) => {
		dispatch(authActions.updateProfileInfo(data))
	}
});

export default compose(withRouter, withFirebase, connect(mapStateToProps, mapDispatchToProps))(LeavesCard);